import React, { Component } from 'react';
import { connect } from 'react-redux';
import shared from '../../../utils/shared.js';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import BRSpan from '../../General/BRSpan';
// import timeHelpers from '../../../utils/timeHelpers.js';
import _ from 'lodash';

// const RANDOM_MODE = "random";
const LAYOUT_MODE = "layout";
const LAYOUT_A = "a";
const LAYOUT_B = "b";
const SHOWING = "showing";
const HIDDEN = "hidden";
const SLIDES_DELAY = 3000;
const PHRASE = "phrase";
const WORD = "word";

class CheckerboardSeattle extends Component {
  constructor(props) {
    super(props);
    try {
      this._currentBackground = null;
      this._currentLayout = LAYOUT_A;
      this._currentWordsLayout = LAYOUT_A;
      this._currentWordMode = Math.floor((Math.random() * 10) + 1) % 2 === 0 ? PHRASE : WORD;
      this._currentMode = LAYOUT_MODE;
      this._currentStatus = HIDDEN;

      this._finishCycle = false;
      this._chosenMode = false;
      this._iterator = 0;
      this._screenCount = 0;
      this._pulledSlidesCount = 0;
      this._quoteCycleTime = 0;
      this._slides = [];
      this._slidesWords = [];
      this._slideScreens = [];
      this._wordsScreens = [];
      this._selectedWordIndex = null;
      this._slideCycleTimeout = this.props.communitiesSlideCycleTime;
      this._slideWordCycleTimeout = this.props.communitiesWordCycleTime;
      this._wordsStyle = null;

      if (this.props.id !== undefined && this.props.id !== null) {
        if (this.props.id === 0 || (this.props.id % 2) === 0) {
          this._currentLayout = LAYOUT_A;
        } else {
          this._currentLayout = LAYOUT_B;
        }
      }

      this.setupElements();

      this._slidesIndex = this._slides.map((x, index) => index);
      this._wordsIndex = this._slidesWords.map((x, index) => index);

      this._pulledSlidesIndex = [];
      this._pulledImages = [];
      this._pulledScreens = [];
      this._pulledWordsIndex = [];
      this._chosenSlidesIndexes = [];
      this._chosenWordsIndexes = [];

      this._invervalTimeoutArr = [];
      this._invervalWordsTimeoutArr = [];
      this._totalScreens = this.props.yScreens * this.props.xScreens;
      this._screenNumbers = Array.apply(null, { length: this._totalScreens }).map(Number.call, Number);
      this._spanStyle = Array.apply(null, { length: this._totalScreens }).map((value) => { return {} });

      /*eslint no-extend-native: ["warn", { "exceptions": ["Array"] }]*/
      Array.prototype.diff = function (a) {
        return this.filter(function (i) { return a.indexOf(i) < 0; });
      };

      if (this.props.setCurrentBackground) {
        this.props.setCurrentBackground(this._currentBackground.image);
      }
      
      this.state = {
        background: this._currentBackground,
        slides: this._slides
      }
    } catch (e) {
      console.log(e)
    }
  }

  componentDidMount() {
    try {
      this.setupSlidesIntervalHandlerB();
    } catch (e) {
      console.log(e);
    }
  }

  componentWillUnmount() {
    this._invervalTimeoutArr.map((timeoutHandler) => {
      return clearTimeout(timeoutHandler);
    });
  }

  setupSlidesIntervalHandlerB = () => {
    // console.log("Entering");
    let slidesLeft = [];

    let calculatedSlideCycleTimeout = this._currentStatus === SHOWING ? this._slideCycleTimeout : SLIDES_DELAY;
    if (this._chosenSlidesIndexes.length < 3 && this._chosenSlidesIndexes.length > 0) {
      calculatedSlideCycleTimeout = 1000;
    }

    let intervalTimeout = setTimeout(() => {
      if (this._currentStatus === HIDDEN) {
        if (this._currentLayout === LAYOUT_A) {
          if (this._slideScreens.length === 0) {
            this._slideScreens = _.shuffle([0, 4, 2]);
            // this._wordsScreens = _.shuffle([3, 1, 5]);
          }
        } else {
          if (this._slideScreens.length === 0) {
            this._slideScreens = _.shuffle([3, 1, 5]);
            // this._wordsScreens = _.shuffle([0, 4 ,2]);
          }
        }

        // Number of images to pull is hardcoded
        // Future change for dynamic selecting this
        slidesLeft = this._slidesIndex.diff(this._pulledSlidesIndex);
        if (slidesLeft.length === 0) {
          this._pulledSlidesIndex = [];
          slidesLeft = this._slidesIndex.diff(this._pulledSlidesIndex);
        }
        let randomSlideIndex = shared.getRandomInt(0, (slidesLeft.length - 1));
        this._chosenSlidesIndexes.push(slidesLeft[randomSlideIndex]);
        this._pulledSlidesIndex.push(slidesLeft[randomSlideIndex]);
        this._pulledSlidesCount++;

        // console.log("Slides Count", this._pulledSlidesCount);

        this._iterator++;
        this.setState({
          chosenSlidesIndexes: this._chosenSlidesIndexes,
          chosenScreens: this._slideScreens,
          iterator: this._iterator,
          showWords: false,
          showSlides: true
        });

        if (this._pulledSlidesCount >= 3) {
          // this.setupWordsInterval();
          this._pulledSlidesCount = 0;
          // console.log("screen count", this._screenCount)

          // if (this._screenCount < 3) {
          //   // console.log("Execute again");
          //   this._screenCount++;
          // }
          this._currentLayout = this._currentLayout === LAYOUT_A ? LAYOUT_B : LAYOUT_A;
          this._currentStatus = SHOWING;
        }

        this.setupSlidesIntervalHandlerB();
        // if (this._screenCount < 3) {
        // }
      } else {
        this._iterator++;
        this.setState({
          iterator: this._iterator,
          showWords: false,
          showSlides: false
        });

        this._currentStatus = HIDDEN;
        this._chosenSlidesIndexes = [];
        this._chosenWordsIndexes = [];
        this._slideScreens = [];
        this._pulledSlidesCount = 0;
        this.setupSlidesIntervalHandlerB();
      }

    }, calculatedSlideCycleTimeout);

    this._invervalTimeoutArr.push(intervalTimeout);
  }

  setupWordsInterval = () => {
    let wordsTimeout = 1000;
    let wordsLeft = [];

    if (this._currentWordsLayout === LAYOUT_A) {
      if (this._wordsScreens.length === 0) {
        this._wordsScreens = _.shuffle([3, 1, 5]);
      }
    } else {
      if (this._wordsScreens.length === 0) {
        this._wordsScreens = _.shuffle([0, 4, 2]);
      }
    }

    if (this._chosenWordsIndexes.length === 0) {
      wordsTimeout = this._slideWordCycleTimeout;
    }

    // clearTimeout(this._invervalWordsTimeout);
    let intervalWordsTimeout = setTimeout(() => {
      wordsLeft = this._wordsIndex.diff(this._pulledWordsIndex);

      if (this._currentWordMode === PHRASE) {
        wordsLeft = _.filter(wordsLeft, (o) => {
          let splitedWords = this._slidesWords[o].split(" ");
          return splitedWords.length > 1;
        });
      } else {
        wordsLeft = _.filter(wordsLeft, (o) => {
          let splitedWords = this._slidesWords[o].split(" ");
          return splitedWords.length === 1;
        });
      }

      if (wordsLeft.length === 0 || wordsLeft.length < 3) {
        this._pulledWordsIndex = [];
        wordsLeft = this._wordsIndex.diff(this._pulledWordsIndex);

        this._chosenWordsIndexes = [];
        if (this._currentWordMode === PHRASE) {
          wordsLeft = _.filter(wordsLeft, (o) => {
            let splitedWords = this._slidesWords[o].split(" ");
            return splitedWords.length > 1;
          });
          if (wordsLeft.length === 0 || wordsLeft.length < 3) {
            wordsLeft = this._wordsIndex.diff(this._pulledWordsIndex);
            wordsLeft = _.filter(wordsLeft, (o) => {
              let splitedWords = this._slidesWords[o].split(" ");
              return splitedWords.length === 1;
            });
            this._currentWordMode = WORD;
          }
        } else {
          wordsLeft = _.filter(wordsLeft, (o) => {
            let splitedWords = this._slidesWords[o].split(" ");
            return splitedWords.length === 1;
          });
          if (wordsLeft.length === 0 || wordsLeft.length < 3) {
            wordsLeft = this._wordsIndex.diff(this._pulledWordsIndex);
            wordsLeft = _.filter(wordsLeft, (o) => {
              let splitedWords = this._slidesWords[o].split(" ");
              return splitedWords.length > 1;
            });
            this._currentWordMode = PHRASE;
          }
        }
      }

      if (wordsLeft.length > 0) {
        let chosenWordIndex = shared.getRandomInt(0, (wordsLeft.length - 1));

        this._chosenWordsIndexes.push(wordsLeft[chosenWordIndex]);
        this._pulledWordsIndex.push(wordsLeft[chosenWordIndex]);
      }

      this._iterator++;
      this.setState({
        chosenWordsIndexes: this._chosenWordsIndexes,
        wordsScreens: this._wordsScreens,
        iterator: this._iterator,
        showWords: true
      });

      if (this._chosenWordsIndexes.length < 3) {
        this.setupWordsInterval();
      } else {
        this._currentWordsLayout = this._currentWordsLayout === LAYOUT_A ? LAYOUT_B : LAYOUT_A;
        this._currentWordMode = this._currentWordMode === PHRASE ? WORD : PHRASE;
        this._pulledWordsIndex = [];
        this._wordsScreens = [];
      }
    }, wordsTimeout);
    this._invervalWordsTimeoutArr.push(intervalWordsTimeout);
  }

  setupElements() {
    let rawSlides = _.get(this.props.module, 'contents.custom_fields.slides_images.val', []);
    let rawBackgrounds = _.get(this.props.module, 'contents.custom_fields.backgrounds_images.val', []);
    let slides = rawSlides.map(slide => {
      return {
        image: shared.dp(this.props.screen, slide)
      }
    });
    if (rawSlides.length < 3) {
      for (let i = 0; i < 3 - rawSlides.length; i++) {
        slides.push({
          image: shared.dp(this.props.screen, { path: "public/img/seattle/general", file_name: "transparent.png" })
        })
      }
    }
    let backgrounds = rawBackgrounds.map(background => {
      return {
        image: shared.dp(this.props.screen, background)
      }
    });
    
    // let slides = [];
    // let backgrounds = [];
    // // let pairLength = 0;

    // let element = this.props.module;
    // let slideshowSlidesModuleId = _.get(element.contents, 'custom_fields.slides.val.value', null);
    // let slideshowBackgroundModuleId = _.get(element.contents, 'custom_fields.backgrounds.val.value', null);
    
    // let slideshowSlidesModule = _.find(this.props.content.dm_active, { id: slideshowSlidesModuleId });
    // let slideshowBackgroundsModule = _.find(this.props.content.dm_active, { id: slideshowBackgroundModuleId });

    // if (slideshowSlidesModule.contents.images.length > 0) {
    //   for (let i = 0; i < slideshowSlidesModule.contents.images.length; i++) {
    //     if (slideshowSlidesModule.contents.images[i]) {
    //       slides.push({ image: shared.dp(this.props.screen, slideshowSlidesModule.contents.images[i])});
    //     }
    //   }
    // }

    // if (slideshowBackgroundsModule.contents.images.length > 0) {
    //   for (let i = 0; i < slideshowBackgroundsModule.contents.images.length; i++) {
    //     if (slideshowBackgroundsModule.contents.images[i]) {
    //       backgrounds.push({ image: shared.dp(this.props.screen, slideshowBackgroundsModule.contents.images[i])});
    //     }
    //   }
    // }

    // console.log("Backgrounds", backgrounds);
    // console.log("slides", slides);

    // Checking words Array
    // let wordPairs = _.get(this.props.element, 'arrays.words_pair', null);
    // let wordsPairsValues = _.get(this.props.element, 'arraysValues.words_pair', null);
    // this._quoteCycleTime = _.get(this.props.element, 'customFields.language_quote_cycle_time.val', 20000);

    // if (wordPairs) {
    //   pairLength = wordPairs.values.length;
    //   for (let i = 0; i < pairLength; i++) {
    //     wordPairs.values[i].main_word['value'] = _.get(wordsPairsValues, '[' + i + '].main_word.val', null);
    //     wordPairs.values[i].words['value'] = _.get(wordsPairsValues, '[' + i + '].words.val', null);
    //   }
    // }

    // this._selectedWordIndex = timeHelpers.indexFromInterval(this._quoteCycleTime, wordPairs.values.length);
    // this._slidesWords = wordPairs.values[this._selectedWordIndex].words.value.split(",");
    // this._slidesWords = _.map(this._slidesWords, (word) => {
    //   let trimmedWord = word.trim();
    //   return trimmedWord;
    // });

    let backgroundIndex = shared.getRandomInt(0, (backgrounds.length - 1));
    this._currentBackground = backgrounds[backgroundIndex];
    this._slides = slides;
  }

  renderSlides = () => {
    let images = [];

    this._pulledSlidesIndex.forEach((value, index) => {
      images.push({
        background: this._slides[value].image,
        screen: this._pulledScreens[index]
      });
    });

    let slideStyle = {
      position: "absolute",
      width: this.props.screen.screenWidth / this.props.xScreens,
      height: this.props.screen.screenHeight / this.props.yScreens,
    }

    let renderedImages = (
      images.map((row, i) => {
        let slideLeft = (row.screen % this.props.xScreens) * slideStyle.width;
        let slideTop = Math.floor(row.screen / this.props.xScreens) * slideStyle.height;

        return (
          <div key={i} style={{ ...slideStyle, left: slideLeft, top: slideTop, backgroundImage: "url(" + row.background + ")", backgroundSize: "cover" }} />
        )
      })
    )

    return renderedImages;
  }

  renderWords = () => {
    let words = [];

    this._pulledWordsIndex.forEach((value, index) => {
      words.push({
        word: this._slidesWords[value],
        screen: this._pulledScreens[index]
      });
    });

    let slideStyle = {
      position: "absolute",
      width: this.props.screen.screenWidth / this.props.xScreens,
      height: this.props.screen.screenHeight / this.props.yScreens,
      display: "table"
    }

    let textShadow = Math.ceil(this.props.screen.screenWidth * 0.001041667);

    let centeredDiv = {
      display: "table-cell",
      verticalAlign: "middle",
      textAlign: "center"
    }

    if (this.props.textShadow) {
      centeredDiv.textShadow = textShadow + "px " + textShadow + "px 3px rgba(0,0,0,1)"
    }

    let style = {
      font: _.get(this.props.element, 'customFields.related_words_style.font', 'Roboto'),
      color: _.get(this.props.element, 'customFields.related_words_style.fontColor', '#FFFFFF'),
      fontSize: _.get(this.props.element, 'customFields.related_words_style.fontSize', "6.5") + "vh",
      fontStyle: _.get(this.props.element, 'customFields.related_words_style.fontStyle', "Normal"),
      fontWeight: _.get(this.props.element, 'customFields.related_words_style.fontWeight', 100),
      lineHeight: _.get(this.props.element, 'customFields.related_words_style.lineHeight', null),
      justification: _.get(this.props.element, 'customFields.related_words_style.justification', null),
      display: _.get(this.props.element, 'customFields.related_words_style.display', true) ? 'block' : 'none',
    }

    let renderedWords = (
      words.map((row, i) => {
        let slideLeft = (row.screen % this.props.xScreens) * slideStyle.width;
        let slideTop = Math.floor(row.screen / this.props.xScreens) * slideStyle.height;
        // let fontSize = row.word.split(" ").length > 1 ? "5.78vh" : "8.10vh";

        return (
          <div key={i} style={{ ...style, ...slideStyle, left: slideLeft, top: slideTop }}>
            <div style={{ ...centeredDiv }}>
              <span style={{ color: "white" }}><BRSpan preWrap str={row.word} /></span>
            </div>
          </div>
        )
      })
    )

    return renderedWords;
  }

  renderLayoutSlides = () => {
    // console.log("Slides Indexes", this.state);
    // console.log("Chosen Screens", this.state);
    try {

      let renderedImages = null;
      let images = [];
  
      if (_.has(this.state, "chosenSlidesIndexes")) {
        this.state.chosenSlidesIndexes.forEach((index, i) => {
          images.push({
            background: this._slides[index].image,
            screen: this.state.chosenScreens[i]
          });
        });
  
        let slideStyle = {
          position: "absolute",
          width: this.props.screen.screenWidth / this.props.xScreens,
          height: this.props.screen.screenHeight / this.props.yScreens,
        }
  
        renderedImages = (
          images.map((row, i) => {
            let slideLeft = (row.screen % this.props.xScreens) * slideStyle.width;
            let slideTop = Math.floor(row.screen / this.props.xScreens) * slideStyle.height;
  
            return (
              <div key={i} style={{ ...slideStyle, left: slideLeft, top: slideTop, backgroundImage: "url(" + row.background + ")", backgroundSize: "cover" }} />
            )
          })
        );
      }
  
      return renderedImages;
    } catch(e) {
      console.log(e);
    }

  }

  renderLayoutWords = () => {
    let renderedWords = null;
    let words = [];

    if (_.has(this.state, "chosenWordsIndexes")) {
      // console.log("Chosen Words Indexes", JSON.stringify(this.state.chosenWordsIndexes));
      if (this.state.chosenWordsIndexes) {
        this.state.chosenWordsIndexes.forEach((index, i) => {
          words.push({
            word: this._slidesWords[index],
            screen: this.state.wordsScreens[i]
          });
        });
      }

      let slideStyle = {
        position: "absolute",
        width: this.props.screen.screenWidth / this.props.xScreens,
        height: this.props.screen.screenHeight / this.props.yScreens,
        display: "table"
      }

      let textShadow = Math.ceil(this.props.screen.screenWidth * 0.001041667);

      let centeredDiv = {
        display: "table-cell",
        verticalAlign: "middle",
        textAlign: "center"
      }

      if (this.props.textShadow) {
        centeredDiv.textShadow = textShadow + "px " + textShadow + "px 3px rgba(0,0,0,1)"
      }

      let style = {
        font: _.get(this.props.element, 'customFields.related_words_style.font', 'Roboto'),
        fontColor: _.get(this.props.element, 'customFields.related_words_style.fontColor', '#FFFFFF'),
        fontSize: _.get(this.props.element, 'customFields.related_words_style.fontSize', "6.5") + "vh",
        fontStyle: _.get(this.props.element, 'customFields.related_words_style.fontStyle', "Normal"),
        fontWeight: _.get(this.props.element, 'customFields.related_words_style.fontWeight', 100),
        lineHeight: _.get(this.props.element, 'customFields.related_words_style.lineHeight', null),
        justification: _.get(this.props.element, 'customFields.related_words_style.justification', null),
        display: _.get(this.props.element, 'customFields.related_words_style.display', true) ? 'table' : 'none',
      }

      if (words.length > 0) {
        renderedWords = (
          words.map((row, i) => {
            let slideLeft = (row.screen % this.props.xScreens) * slideStyle.width;
            let slideTop = Math.floor(row.screen / this.props.xScreens) * slideStyle.height;

            return (
              <div key={i} style={{ ...style, ...slideStyle, left: slideLeft, top: slideTop }}>
                <div style={{ ...centeredDiv }}>
                  <span style={{ color: style.fontColor }}><BRSpan preWrap str={row.word} /></span>
                </div>
              </div>
            )
          })
        );
      }
    }

    return renderedWords;
  }

  render() {
    try {
      let slides = null;
      // let words = null;
  
      if (this._currentMode === LAYOUT_MODE) {
        // console.log("Got in layout mode");
        slides = this.renderLayoutSlides();
        // words = this.renderLayoutWords();
      } else {
        // console.log("Got in random mode");
        slides = this.renderSlides();
        // words = this.renderWords();
      }
  
      return (
        <div style={{ position: "absolute", top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, backgroundSize: "cover", backgroundImage: "url(" + this.state.background.image + ")" }}>
          <CSSTransitionGroup
            component='div'
            transitionName='slowfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.iterator}>
              {this.state.showSlides ? slides : null}
              {/* {this.state.showWords ? words : null} */}
            </div>
          </CSSTransitionGroup>
        </div>
      )

    } catch(e) {
      console.log(e)
      return (
        <div></div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  let textShadow = shared.parseStringParam(window.location.href, "textShadow");
  let id = shared.parseStringParam(window.location.href, "id");
  let communitiesSlideCycleTime = Number(_.get(state.content.settings.custom_vars, 'slidescycletime', 27000));
  let communitiesWordCycleTime = Number(_.get(state.content.settings.custom_vars, 'wordscycletime', 3000));

  if (!textShadow) {
    textShadow = false;
  }

  let dm;
  if (state.options.idleModule === undefined) {
    dm = state.content.dm_active[state.active_module]
  } else {
    dm = _.find(state.content.stories, { id: state.options.idleModule });
  }

  return {
    id: id,
    module: dm,
    screen: state.screen,
    content: state.content,
    communitiesSlideCycleTime: communitiesSlideCycleTime,
    communitiesWordCycleTime: communitiesWordCycleTime,
    textShadow: textShadow
  };
};

export default connect(mapStateToProps)(CheckerboardSeattle);


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/CheckerboardSeattle.jsx